import isColorDark from "./isColorDark";

import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import NotificationsIcon from '@mui/icons-material/Notifications';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AlarmOffIcon from '@mui/icons-material/AlarmOff';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { Box, Tooltip, Typography } from "@mui/material";
import TaskAltIcon from '@mui/icons-material/TaskAlt';

// Definição de cores para os tipos
const renderColor = {
    whatsapp: "#25d366",
    schedule: "#ffcc00",
    email: "#cd2030",
    call: "#3923ef",
    default: "#3923ef"
};

const calendarEventContent = (eventInfo) => {
    const event = eventInfo.event || eventInfo;
    const {
        type = 'default',
        color: eventColor,
        isReschedule,
        isRescheduled,
        isFinished,
        isRescheduleTicket,
        contact,
        queue
    } = event || {};
    const color = eventColor || renderColor[type];

    // Define a cor do texto (sempre branca pois o eventPropGetter aplica fundos coloridos)
    const textColor = '#ffffff';

    // Para tickets reagendados, criar um layout mais profissional
    if (isRescheduleTicket) {
        const { status } = event;

        // Definir labels e ícones baseados no status
        const statusInfo = {
            pending: { label: 'Pendente', icon: EventRepeatIcon },
            executed: { label: 'Executado', icon: TaskAltIcon }
        };

        const currentStatus = statusInfo[status] || statusInfo.pending;
        const StatusIcon = currentStatus.icon;

        return (
            <Tooltip
                title={
                    <Box>
                        <Typography variant="body2" fontWeight="bold">
                            Ticket Reagendado - {currentStatus.label}
                        </Typography>
                        <Typography variant="caption" display="block">
                            {contact?.name || 'Sem nome'}
                        </Typography>
                        {queue && (
                            <Typography variant="caption" display="block">
                                Setor: {queue.name}
                            </Typography>
                        )}
                    </Box>
                }
                arrow
            >
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        overflow: 'hidden',
                        position: 'relative',
                        padding: '2px 6px',
                    }}
                >
                    <StatusIcon
                        sx={{
                            color: textColor,
                            width: '16px',
                            height: '16px',
                            flexShrink: 0
                        }}
                    />
                    <Typography
                        sx={{
                            color: textColor,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            flex: 1,
                            letterSpacing: '0.3px'
                        }}
                    >
                        {contact?.name || 'Ticket Reagendado'}
                    </Typography>
                </Box>
            </Tooltip>
        );
    }

    // Layout padrão para outros eventos
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                overflow: 'hidden',
                position: 'relative',
                padding: '2px 4px',
                // Remover backgroundColor daqui pois será aplicado pelo eventPropGetter
            }}
        >
            <Typography
                sx={{
                    color: textColor,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontWeight: 500,
                    fontSize: '0.8rem',
                    maxWidth: 'calc(100% - 20px)', // Espaço para ícones
                    flex: 1,
                }}
            >
                {event.title}
            </Typography>
            {isRescheduled && (
                <AlarmOffIcon
                    sx={{
                        color: textColor,
                        width: '18px',
                        height: '18px'
                    }}
                />
            )}
            {isFinished && (
                <TaskAltIcon
                    sx={{
                        color: textColor,
                        width: '18px',
                        height: '18px'
                    }}
                />
            )}
        </Box>
    );
};

export default calendarEventContent;
